<template>
    <div>
        <v-textarea
            v-model="value"
            :label="label"
            :error-messages="errors"
            class="mt-0 pt-1 rightFlexDirection"
            filled
            name="input-7-4"
            :rules="rules"
        ></v-textarea>

        <v-container>
          <v-row class="d-flex flex-wrap justify-space-between">

            <p class="mx-2">
              <span v-text="$t('FORMS.CharCount') "></span> : <span class="font-weight-bold"
                                                                    v-text="' ' +textInfo.total"></span>
            </p>


            <p class="mx-2">
              <span v-text="$t('FORMS.FarsiCharCount')"></span> : <span class="font-weight-bold"
                                                                        v-text="' ' + textInfo.farsi"></span>
            </p>

            <p class="mx-2">
              <span v-text="$t('FORMS.EnglishCharCount')"></span> : <span class="font-weight-bold"
                                                                          v-text="' ' + (textInfo.total - textInfo.farsi)"></span>
            </p>

            <p class="mx-2">
              <span v-text="$t('FORMS.SmsCount')"></span> : <span class="font-weight-bold"
                                                                  v-text="' ' + textInfo.smsCount"></span>
            </p>

            <p class="mx-2">
              <span v-text="$t('FORMS.SmsLang')"></span> : <span class="font-weight-bold"
                                                                 v-text="' ' + $t('LANGUAGE.' +textInfo.lang.name)"></span>
            </p>

          </v-row>
        </v-container>
    </div>
</template>

<script>
import {getTextSmsInfo, Language} from "@/Utilities/Utilities";

export default {
  name: "Content",
  props:["value", "errors", "rules", "label"],
  data() {
    return {
      textInfo: {
        total: 0,
        farsi: 0,
        smsCount: 0,
        lang: Language.English,
        price: 0
      },
    }
  },
  watch: {
    value(n, v) {
      let info = getTextSmsInfo(n)
      this.textInfo.total = n.length
      this.textInfo.farsi = info.persianChar
      this.textInfo.smsCount = info.smsCount
      this.textInfo.lang = info.lang
      this.$emit('changeValue', n)

    },
  }
}
</script>

<style scoped>

</style>